/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_TitleInputs */

const en_landing_pricing_compare_title = /** @type {(inputs: Landing_Pricing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare plans in detail`)
};

const zh_landing_pricing_compare_title = /** @type {(inputs: Landing_Pricing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`方案详细对比`)
};

/**
* | output |
* | --- |
* | "Compare plans in detail" |
*
* @param {Landing_Pricing_Compare_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_title = /** @type {((inputs?: Landing_Pricing_Compare_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_title(inputs)
	return zh_landing_pricing_compare_title(inputs)
});
export { landing_pricing_compare_title as "landing.pricing.compare_title" }